import axiosClient from '../configs/axios';


class transfertoplant {
    // Get list 
    async gettransfartoplant(params) {
        try {
        const login_details = sessionStorage.getItem("loginUser");
        const userD = JSON.parse(login_details);
        const userInfo = userD?.result?.userInfo;
        const unit_id = userInfo?.depot_id || userInfo?.plant_id ;
        const response = await axiosClient.get(
                `/tranfertoplant/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}&unit_id=${unit_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // GET INWARD NO

     async getInwardNo(depot_id) {
        try {
        


            const response = await axiosClient.get(
                `/tranfertoplant/inwardNo?depot_id=${depot_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }



    // Add 
    async addtransfartoplant(data) {
        try {
            const response = await axiosClient.post('/tranfertoplant/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeletetransfartoplant(data) {
        try {
            const response = await axiosClient.put(`/tranfertoplant/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new transfertoplant(); 